import PolicyContentPage from "../components/PolicyContentPage";

const PrivacyPolicy = () => (
  <PolicyContentPage title="Privacy Policy" policyType="privacyPolicy" />
);

export default PrivacyPolicy;
